import React from "react";
import { useUnit } from "effector-react";
import { useSearchParams } from "react-router-dom";
import { setTotemId, WashingStore } from "../../stores/WashingStore/WashingStore";
import StartPage from "./pages/StartPage/StartPage";
import ChooseLicence from "./pages/ChooseLicence/ChooseLicence";
import ChooseWashing from "./pages/ChooseWashing/ChooseWashing";
import WashingPayment from "./pages/WashingPayment/WashingPayment";
import { Container, MissingTotemId } from "./TotemWashingStyles";
import FailedPayment from "./pages/FailedPayment/FailedPayment";
import ProcessingPayment from "./pages/ProcessingPayment/ProcessingPayment";
import SuccessPayment from "./pages/SuccessPayment/SuccessPayment";
import ChooseTax from "./pages/ChooseTax/ChooseTax";
import SendReceipt from "./pages/SendReceipt/SendReceipt";
import InactivityTimer from "./components/InactivityTimer/InactivityTimer";
import { PAGES } from "../../stores/WashingStore/WashingStore.types";
import { setStation } from "../../stores/UserStore/UserStore";
import FailedActivation from "./pages/FailedActivation/FailedActivation";

const pages = [
  StartPage, // 0
  ChooseLicence, // 1
  ChooseWashing, // 2
  WashingPayment, // 3
  ProcessingPayment, // 4
  ChooseTax, // 5
  SendReceipt, // 6
  SuccessPayment, // 7
  FailedPayment, // 8
  FailedActivation, // 9
];

const TotemWashing: React.FC = () => {
  const [searchParams] = useSearchParams();
  const totemId = searchParams.get("totemId") ?? "";
  const station = searchParams.get("station") ?? "";

  const { currPage } = useUnit(WashingStore);

  React.useEffect(() => {
    setTotemId(totemId);
    setStation(station);
  }, [totemId, station]);

  const renderPage = () => {
    const PageComponent = pages[currPage];
    return <PageComponent />;
  };

  const renderTimer = () => {
    if (
      currPage === PAGES.CHOOSE_WASHING ||
      currPage === PAGES.WASHING_PAYMENT ||
      currPage === PAGES.SEND_RECEIPT
    )
      return <InactivityTimer timeout={300000} />;

    return <></>;
  };

  if (!totemId) {
    return <MissingTotemId>Preencha o totemId</MissingTotemId>;
  }

  return (
    <Container>
      {renderTimer()}
      {renderPage()}
      {/* <ConnectionKeepAlive totemId={totemId} /> */}
    </Container>
  );
};

export default TotemWashing;
